import "./TrackRow.css";
import { Artwork } from "@touchscreen/brand-kit";

export function TrackRow(props: {
  title: string;
  artist: string;
  artworkUrl?: string | null;
  trailing?: React.ReactNode;
  onClick?: () => void;
}): React.JSX.Element {
  const artwork = (
    <>
      <Artwork className="track-row__artwork" src={props.artworkUrl} />
      <div className="track-row__meta">
        <span className="track-row__title">{props.title}</span>
        <span className="track-row__artist">{props.artist}</span>
      </div>
    </>
  );

  return (
    <div className="track-row">
      {props.onClick ? (
        <button className="track-row__hit" onClick={props.onClick}>
          {artwork}
        </button>
      ) : (
        <div className="track-row__hit">{artwork}</div>
      )}
      {props.trailing ? <div className="track-row__trailing">{props.trailing}</div> : null}
    </div>
  );
}
